import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './HoverComponent.scss';
var type2image = {
    muro: 'il35_-_muro_v3.svg',
    poll: 'il33_-_poll_v3.svg',
    status: 'il30_-_status_update_v3.svg',
    deviant: 'il29_-_deviation_v3.svg',
    journal: 'il31_-_journal_v3.svg',
    literature: 'il32_-_literature_v3.svg',
    motionBook: 'il34_-_motion_book_v3.svg',
    commission: 'il62_-_commission_v3.svg',
};
var HoverComponent = function (_a) {
    var svg = _a.svg, title = _a.title, context = _a.context, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s.root, className) },
        React.createElement("div", { className: s.container },
            React.createElement("div", { className: s.svg },
                React.createElement("img", { src: "https://st.deviantart.net/eclipse/popups/hover-component/" + type2image[svg], alt: svg })),
            React.createElement("div", { className: s.title }, t(title)),
            React.createElement("div", { className: s.context }, t(context)))));
};
HoverComponent.displayName = 'HoverComponent';
export default HoverComponent;
//# sourceMappingURL=HoverComponent.js.map